export default __webpack_public_path__ + "static/media/esms-logo-blanco.3a390490.svg";